import Vue from 'vue'

const url = 'alfakodos'
const alfakodos = {
  namespaced: true,
  state: {
    alfakodos: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.alfakodos = data
    },
    NEW(state, data) {
      state.alfakodos.unshift(data)
    },
    UPD(state, data) {
      const index = state.alfakodos.findIndex(t => t.id == data)
      if(index !== -1) {
        state.alfakodos.splice(index, 1, data)
      }
    },
    DEL(state, data) {
      state.alfakodos = state.alfakodos.filter(alfakodo => alfakodo.id != data.id)
    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get(url)
      commit('SET', response.data)
    },
    async create({commit}, alfakodo) {
      Vue.prototype.$axios.post(url, alfakodo).then(res => {
        Vue.prototype.$toastr.s('Created new alfakodo.')
        commit('NEW', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create alfakodo.')
      })
    },
    async update({commit}, alfakodo) {
      Vue.prototype.$axios.put(url + '/' + alfakodo.id, alfakodo).then(res => {
        Vue.prototype.$toastr.s('Updated ' + alfakodo.name)
        commit('UPD', res.data)
      }).catch(err => {
        Vue.prototype.$toastr.e('Error.', err.data)
        console.log(err)
      })
    },
    async remove({commit}, alfakodo) {
      const response = await Vue.prototype.$axios.delete(url + '/' + alfakodo.id)
      Vue.prototype.$toastr.s('Deleted Alfakodo Successfully')
      commit('DEL', response.data)
    }
  },
  getters: {
    all: state => state.alfakodos,
    byClient:(state) => (id) => {
      return state.alfakodos.filter(alfakodos => {
        return alfakodos.client_id == id
      })
    }
  }
}

export default alfakodos